const responseNodes = (result) => [
  result,
  result?.response,
  result?.response?.response,
  result?.response?.response?.response,
].filter(Boolean);

export const isUserVaultUpdateSuccessful = (result) => {
  const nodes = responseNodes(result);
  const statusCode = nodes
    .map((node) => Number(node?.statusCode))
    .find((code) => Number.isFinite(code) && code >= 400);
  const hasError = nodes.some(
    (node) => node?.error || (Array.isArray(node?.errors) && node.errors.length > 0),
  );
  const success = nodes.find((node) => typeof node?.success === "boolean")?.success;

  return statusCode === undefined && !hasError && success === true;
};
